import { render } from "./AdminCompaniesView.vue?vue&type=template&id=87f1cece&ts=true&lang=pug"
import script from "./AdminCompaniesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCompaniesView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__